(function () {
  function start() {
    var root = document.querySelector('[data-ns-native-promo]');
    if (!root || root.__nsNativePromo) return;
    root.__nsNativePromo = true;

    var modal = root.querySelector('[data-ns-native-promo-modal]');
    var dialog = root.querySelector('.ns-b1g2-dialog');
    var gift = root.querySelector('[data-ns-native-promo-gift]');
    var giftOptions = Array.prototype.slice.call(root.querySelectorAll('[data-ns-native-promo-gift]'));
    var required = Number(root.dataset.required || 1);
    var selected = required === 1 ? [gift] : [];
    var confirmButton = root.querySelector('[data-ns-native-promo-confirm]');
    var skipButton = root.querySelector('[data-ns-native-promo-skip]');
    var errorBox = root.querySelector('[data-ns-native-promo-error]');
    var closeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-ns-native-promo-close]'));
    var code = root.dataset.discountCode;
    var promoKey = root.dataset.promoKey;
    var label = root.dataset.offerLabel || code;
    var cartUrl = root.dataset.cartUrl || '/cart';
    var pendingForm = null;
    var pendingExtras = [];
    var pendingDestination = 'cart';
    var lastFocused = null;
    var busy = false;
    var claimed = false;
    var claimedQuantity = 0;
    var keepExistingGifts = false;
    var claimStatePromise = null;
    var promotionStartPending = false;

    function routesRoot() { return window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/'; }
    function requestJson(url, options) {
      return fetch(url, options).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (payload) {
          if (!response.ok) throw new Error(payload.description || payload.message || 'The cart could not be updated.');
          return payload;
        });
      });
    }
    function wait(ms) { return new Promise(function (resolve) { window.setTimeout(resolve, ms); }); }
    function setError(message) { errorBox.textContent = message || ''; errorBox.hidden = !message; }
    function mainForm() {
      // Desktop Ani preview may display complementary forms before the main product.
      // Resolve its existing observed form explicitly; all other pages keep the original behavior.
      var supplement = document.querySelector('ns-ani-desktop-fill:not([hidden])');
      var mainRerender = supplement && supplement.closest('product-rerender[observe-form]');
      var observedForm = mainRerender && document.getElementById(mainRerender.getAttribute('observe-form'));
      if (observedForm && observedForm.matches('form[action*="/cart/add"]')) return observedForm;
      var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
      return forms.find(function (form) { return form.querySelector('buy-buttons') && !form.closest('[id*="quick-buy"], quick-buy-modal, .quick-buy-modal'); }) ||
        forms.find(function (form) { return form.matches('form[is="product-form"]') && !form.closest('[id*="quick-buy"], quick-buy-modal, .quick-buy-modal'); }) || null;
    }
    function isMainForm(form) { return !!form && form === mainForm(); }
    function formItem(form, token) {
      var data = new FormData(form);
      var id = Number(data.get('id'));
      var quantity = Math.max(1, Number(data.get('quantity') || 1));
      if (!id) throw new Error('Please select an available product option first.');
      var properties = {};
      data.forEach(function (value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (match && value !== '') properties[match[1]] = value;
      });
      if (token) {
        properties['_NS promotion offer'] = 'true';
        properties['_NS promotion bundle'] = token;
        properties['_NS promotion key'] = promoKey;
      }
      var item = { id: id, quantity: quantity };
      if (Object.keys(properties).length) item.properties = properties;
      var sellingPlan = data.get('selling_plan');
      if (sellingPlan) item.selling_plan = Number(sellingPlan);
      return item;
    }
    function giftItem(token, option) {
      return { id: Number((option || gift).dataset.variantId), quantity: 1, properties: {
        '_NS promotion gift': 'true', '_NS promotion bundle': token, '_NS promotion key': promoKey
      }};
    }
    function safeExtras(extras) {
      return (extras || []).filter(function (item) { return item && Number(item.id); }).map(function (item) {
        var next = { id: Number(item.id), quantity: Math.max(1, Number(item.quantity || 1)) };
        if (item.properties && typeof item.properties === 'object') next.properties = item.properties;
        return next;
      });
    }
    function hasValidBundle(cart) {
      if (promoKey === 'choose2') {
        return (cart.items || []).some(function (parent) {
          var props = parent.properties || {};
          return props['_NS promotion offer'] === 'true' && props['_NS promotion key'] === promoKey && props['_NS promotion bundle'] && (cart.items || []).some(function (item) {
            var giftProps = item.properties || {};
            return giftProps['_NS promotion gift'] === 'true' && giftProps['_NS promotion key'] === promoKey && giftProps['_NS promotion bundle'] === props['_NS promotion bundle'] && item.quantity === 1 && item.final_line_price === 0;
          });
        });
      }
      return (cart.items || []).some(function (item) {
        var props = item.properties || {};
        return props['_NS promotion offer'] === 'true' && props['_NS promotion key'] === promoKey;
      }) && (cart.items || []).some(function (item) {
        var props = item.properties || {};
        return props['_NS promotion gift'] === 'true' && props['_NS promotion key'] === promoKey && item.quantity === 1;
      });
    }
    function updateTrigger() {
      Array.prototype.slice.call(document.querySelectorAll('[data-ns-native-promo-open]')).forEach(function (button) {
        var copy = button.querySelector('[data-ns-native-promo-trigger-copy]');
        var action = button.querySelector('[data-ns-native-promo-trigger-action]');
        if (copy) copy.textContent = claimed ? 'Your gift is already in the cart' : 'See your included gift';
        if (action) action.textContent = claimed ? 'View cart' : 'View';
      });
    }
    function trigger() {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'ns-b1g2-trigger';
      button.setAttribute('data-ns-native-promo-open', '');
      button.innerHTML = '<span class="ns-b1g2-trigger__mark" aria-hidden="true">FREE</span>' +
        '<span class="ns-b1g2-trigger__copy"><strong>' + escapeHtml(label) + '</strong><span data-ns-native-promo-trigger-copy>See your included gift</span></span>' +
        '<span class="ns-b1g2-trigger__action" data-ns-native-promo-trigger-action>View</span>';
      return button;
    }
    function escapeHtml(value) { var div = document.createElement('div'); div.textContent = value; return div.innerHTML; }
    function ensureTrigger() {
      document.body.classList.add('ns-b1g2-enabled');
      if (window.NSPromoAtc && typeof window.NSPromoAtc.refresh === 'function') window.NSPromoAtc.refresh();
    }
    function finishDestination(destination) { if(destination==='shop_pay'){ window.location.assign(destinationUrl(destination)); return; } busy=false;claimStatePromise=null;close();document.dispatchEvent(new CustomEvent('ns-story:cartadded')); }
    function destinationUrl(destination) {
      return destination === 'shop_pay' ? routesRoot() + 'checkout?payment=shop_pay' : cartUrl;
    }
    function open(form, extras, destination) {
      keepExistingGifts = required === 2 && claimed;
      pendingForm = form || mainForm();
      pendingExtras = safeExtras(extras);
      pendingDestination = destination === 'shop_pay' ? 'shop_pay' : 'cart';
      lastFocused = document.activeElement;
      setError('');
      confirmButton.textContent = pendingDestination === 'shop_pay' ? 'Continue to Shop Pay' : 'Add to cart';
      if (required === 2) { selected = []; renderSelection(); }
      modal.hidden = false;
      document.body.classList.add('ns-b1g2-modal-open');
      window.requestAnimationFrame(function () { dialog.focus(); });
    }
    function renderSelection() {
      var grid = root.querySelector('.ns-b1g2-grid');
      if (grid) grid.hidden = keepExistingGifts;
      if (keepExistingGifts) {
        root.querySelector('[data-ns-native-promo-count]').textContent = claimedQuantity + '/2';
        root.querySelector('[data-ns-native-promo-status]').textContent = 'Your Choose 2 offer is already in your cart. One pair per order.';
        confirmButton.disabled = busy;
        confirmButton.textContent = pendingDestination === 'shop_pay' ? 'Add saber & continue to checkout' : 'Add saber — keep my current gifts';
        return;
      }
      giftOptions.forEach(function (option) { option.setAttribute('aria-pressed', selected.indexOf(option) !== -1 ? 'true' : 'false'); });
      root.querySelector('[data-ns-native-promo-count]').textContent = selected.length + '/' + required;
      root.querySelector('[data-ns-native-promo-status]').textContent = selected.length === required ? 'Your 2 FREE sabers are ready' : 'Choose ' + (required - selected.length) + ' more';
      confirmButton.disabled = busy || selected.length !== required;
      confirmButton.textContent = selected.length !== required ? 'Select ' + (required - selected.length) + ' more FREE saber' + (required - selected.length > 1 ? 's' : '') : pendingDestination === 'shop_pay' ? 'Continue to Shop Pay' : 'Add saber + 2 FREE gifts';
    }
    if (required === 2) giftOptions.forEach(function (option) {
      option.addEventListener('click', function () {
        if (busy || option.disabled) return;
        var index = selected.indexOf(option);
        if (index !== -1) selected.splice(index, 1);
        else if (selected.length < required) selected.push(option);
        else { setError('Deselect a gift to choose a different style.'); return; }
        setError(''); renderSelection();
      });
    });
    function close() {
      if (busy) return;
      modal.hidden = true;
      document.body.classList.remove('ns-b1g2-modal-open');
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
      pendingForm = null;
      pendingExtras = [];
      pendingDestination = 'cart';
    }
    function removeBundle(cart, token) {
      var updates = {};
      (cart.items || []).forEach(function (item) {
        if (item.properties && item.properties['_NS promotion bundle'] === token) updates[item.key] = 0;
      });
      if (!Object.keys(updates).length) return Promise.resolve();
      return requestJson(routesRoot() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: updates }) }).catch(function () {});
    }
    function verify(cart, token) {
      var items = (cart.items || []).filter(function (item) { return item.properties && item.properties['_NS promotion bundle'] === token; });
      var offer = items.some(function (item) { return item.properties['_NS promotion offer'] === 'true'; });
      var gifts = items.filter(function (item) { return item.properties['_NS promotion gift'] === 'true'; });
      return offer && gifts.length === required && gifts.every(function (item) { return item.quantity === 1 && item.original_line_price > 0 && item.final_line_price === 0; });
    }
    function discountCodes(cart) {
      var values = [];
      (cart.discount_codes || []).forEach(function (discount) {
        var value = String(discount && discount.code || '').trim();
        if (value && values.indexOf(value) === -1) values.push(value);
      });
      if (code && values.indexOf(code) === -1) values.push(code);
      return values;
    }
    function applyAndVerify(token, tries, codes) {
      // Shopify applies the line-targeted automatic discount in the add request.
      // One fresh cart read verifies it; no artificial wait or code overwrite.
      if (root.dataset.discountMode === 'automatic') {
        function confirmAutomatic(remaining) {
          return requestJson(routesRoot() + 'cart.js').then(function (cart) {
            if (verify(cart, token)) return cart;
            if (remaining > 1) {
              var delay = remaining === 3 ? 250 : 450;
              return wait(delay).then(function () { return confirmAutomatic(remaining - 1); });
            }
            var error = new Error('Your FREE gift discount could not be confirmed. Please review your cart before trying again.');
            error.cart = cart;
            throw error;
          });
        }
        return confirmAutomatic(Math.max(1, Number(tries) || 3));
      }
      if (!codes) {
        return requestJson(routesRoot() + 'cart.js').then(function (cart) {
          return applyAndVerify(token, tries, discountCodes(cart));
        });
      }
      return requestJson(routesRoot() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: codes.join(',') }) })
        .then(function () { return wait(300); })
        .then(function () { return requestJson(routesRoot() + 'cart.js'); })
        .then(function (cart) {
          if (verify(cart, token)) return cart;
          if (tries > 1) return wait(400).then(function () { return applyAndVerify(token, tries - 1, codes); });
          var error = new Error('The promotion could not be confirmed. Your cart has not been changed. Please try again.');
          error.cart = cart;
          throw error;
        });
    }
    function addProductOnly(form, extras, destination) {
      if (busy) return;
      busy = true;
      setError('');
      var items;
      try { items = [formItem(form, null)].concat(safeExtras(extras)); } catch (error) { busy = false; setError(error.message); return; }
      requestJson(routesRoot() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function () { finishDestination(destination); })
        .catch(function (error) { busy = false; setError(error.message || 'The product could not be added. Please try again.'); });
    }
    function addPromotion(form, extras, destination) {
      if (busy) return;
      if (keepExistingGifts) { addProductOnly(form, extras, destination); return; }
      if (selected.length !== required) return;
      busy = true;
      setError('');
      var token = 'ns-' + promoKey + '-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
      var items;
      try { items = [formItem(form, token)].concat(selected.map(function (option) { return giftItem(token, option); }), safeExtras(extras).map(function(item){ item.properties=Object.assign({},item.properties,{'_NS promotion bundle':token}); return item; })); } catch (error) { busy = false; setError(error.message); return; }
      confirmButton.disabled = true;
      confirmButton.textContent = 'Adding your saber and FREE gifts…';
      skipButton.disabled = true;
      var beforeAdd = required === 2 ? requestJson(routesRoot() + 'cart.js') : Promise.resolve(null);
      beforeAdd.then(function (cart) {
        if (cart && hasValidBundle(cart)) {
          rememberClaim(cart); keepExistingGifts = true; busy = false; skipButton.disabled = false; renderSelection();
          setError('Your Choose 2 gift offer is already in the cart. Confirm below to add only this saber, keeping your current gifts.');
          return false;
        }
        return requestJson(routesRoot() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) });
      })
        .then(function (added) { return added === false ? false : applyAndVerify(token, 3); })
        .then(function (cart) { if (cart !== false) finishDestination(destination); })
        .catch(function (error) {
          var cartPromise = error.cart ? Promise.resolve(error.cart) : requestJson(routesRoot() + 'cart.js');
          cartPromise.then(function (cart) { return removeBundle(cart, token); }).catch(function () {}).finally(function () {
            busy = false;
            confirmButton.disabled = false;
            skipButton.disabled = false;
            if (required !== 2) confirmButton.textContent = 'Add to cart';
            if (required === 2) renderSelection();
            setError(error.message || 'The promotion could not be added. Please try again.');
          });
        });
    }
    function startPromotion(form, extras, destination) {
      if (!form) { setError('The product form could not be found. Please refresh and try again.'); return; }
      if (promotionStartPending) return;
      promotionStartPending = true;
      loadClaimed().then(function () {
        promotionStartPending = false;
        if (claimed && required !== 2) addProductOnly(form, extras, destination);
        else open(form, extras, destination);
      });
    }
    function loadClaimed() {
      if (claimStatePromise) return claimStatePromise;
      claimStatePromise = requestJson(routesRoot() + 'cart.js').then(function (cart) {
        rememberClaim(cart);
        return cart;
      }).catch(function () { return null; });
      return claimStatePromise;
    }
    function rememberClaim(cart) {
      claimed = hasValidBundle(cart);
      claimedQuantity = (cart.items || []).filter(function (item) { return item.properties && item.properties['_NS promotion key'] === promoKey && item.properties['_NS promotion gift'] === 'true'; }).reduce(function (sum, item) { return sum + item.quantity; }, 0);
      updateTrigger();
    }
    closeButtons.forEach(function (button) { button.addEventListener('click', close); });
    confirmButton.addEventListener('click', function () {
      addPromotion(pendingForm || mainForm(), pendingExtras, pendingDestination);
    });
    skipButton.addEventListener('click', function () {
      var form = pendingForm || mainForm();
      var extras = pendingExtras.slice();
      var destination = pendingDestination;
      close();
      addProductOnly(form, extras, destination);
    });
    window.addEventListener('click', function (event) {
      var openButton = event.target.closest('[data-ns-native-promo-open]');
      if (openButton) { event.preventDefault(); if (claimed) window.location.assign(cartUrl); else open(mainForm(), [], 'cart'); return; }
      var add = event.target.closest('button[data-action="add-to-cart"], input[data-action="add-to-cart"]');
      if (!add) return;
      var form = add.form || add.closest('form[action*="/cart/add"]');
      if (!isMainForm(form)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      startPromotion(form, [], 'cart');
    }, true);
    document.addEventListener('submit', function (event) {
      if (!isMainForm(event.target)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      startPromotion(event.target, [], 'cart');
    }, true);
    document.addEventListener('keydown', function (event) {
      if (modal.hidden) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      if (event.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(dialog.querySelectorAll('button:not(:disabled), [href], input:not(:disabled), [tabindex]:not([tabindex="-1"])')).filter(function (element) { return element.getClientRects().length > 0; });
      if (!focusable.length) return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    window.NSNativePromo = {
      start: function (form, extras) { startPromotion(form, extras, 'cart'); },
      startShopPay: function (form, extras) { startPromotion(form, extras, 'shop_pay'); }
    };
    ensureTrigger();
    loadClaimed();
  }
  start(); // Loaded after article markup; do not wait for unrelated deferred apps.
})();

